import React, { useState } from 'react';
import { Form, Input, Select, message } from 'antd';
import { useTranslation } from 'react-i18next';
import ResponsiveModal from '../ResponsiveModal/ResponsiveModal';
import { reportContact } from '../../Messages/MessagesServices';
import { useErrorHandler } from '../../../Hooks/useErrorHandler';

const { TextArea } = Input;

const ReportUserModal = ({ visible, onCancel, contactId }) => {
    const { t } = useTranslation();
    const [reportForm] = Form.useForm();
    const [reportLoading, setReportLoading] = useState(false);
    const { handleError } = useErrorHandler();

    const handleSubmitReport = async () => {
        if (!contactId) return;

        try {
            const values = await reportForm.validateFields();
            setReportLoading(true);

            await reportContact(contactId, {
                reason: values.reason,
                comment: values.comment
            });

            message.success(t('user_reported_successfully'));
            onCancel();
            reportForm.resetFields();
        } catch (error) {
            if (error.errorFields) return;
            handleError(error, reportForm);
        } finally {
            setReportLoading(false);
        }
    };

    return (
        <ResponsiveModal
            title={t('report_user')}
            open={visible}
            onOk={handleSubmitReport}
            onCancel={() => {
                onCancel();
                reportForm.resetFields();
            }}
            okText={t('report')}
            cancelText={t('cancel')}
            confirmLoading={reportLoading}
            okButtonProps={{ danger: true }}
        >
            <Form form={reportForm} layout="vertical">
                <Form.Item
                    name="reason"
                    label={t('reason')}
                    rules={[{ required: true, message: t('please_select_a_reason') }]}
                >
                    <Select placeholder={t('select_a_reason')}>
                        <Select.Option value="spam">{t('report_reason_spam')}</Select.Option>
                        <Select.Option value="harassment">{t('report_reason_harassment')}</Select.Option>
                        <Select.Option value="inappropriate_content">{t('report_reason_inappropriate_content')}</Select.Option>
                        <Select.Option value="fake_profile">{t('report_reason_fake_profile')}</Select.Option>
                        <Select.Option value="other">{t('report_reason_other')}</Select.Option>
                    </Select>
                </Form.Item>

                <Form.Item
                    name="comment"
                    label={t('additional_comments')}
                    tooltip={t('optional')}
                >
                    <TextArea
                        rows={4}
                        placeholder={t('provide_additional_details_optional')}
                        maxLength={500}
                        showCount
                        dir="auto"
                        style={{ unicodeBidi: 'plaintext' }}
                    />
                </Form.Item>
            </Form>
        </ResponsiveModal>
    );
};

export default ReportUserModal;
